<div class="row">
  <div class="col-md-3">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="bg-primary p-10 m-b-15 d-block">
        <div>
          <mat-form-field class="w-100 m-b-sm" subscriptSizing="dynamic">
            <mat-select [value]="sectorId" placeholder="{{ 'SelectSector' | translate }}" (valueChange)="changeSector($event)">
              <mat-option value="">{{ 'SelectSector' | translate }}</mat-option>
              <mat-option [value]="cat.key" *ngFor="let cat of sectors">{{ cat.value }}
              </mat-option>
            </mat-select>
            <mat-label>{{ 'SelectSector' | translate }}</mat-label>
          </mat-form-field>
        </div>
        <div class="mat-mdc-card-header">
          <input class="inputTxt" placeholder="{{ 'search' | translate }}" maxlength="100" #searchVal
                 (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
                 (keyup.enter)="checkSearchVal(searchVal.value)"/>
          <i-tabler name="search" class="icon-20 d-flex icon m-l-6 m-t-6"></i-tabler>
        </div>
      </mat-card-header>
      <div class="col-md-12"  *ngIf="AllProductPerCategory.length!=0">
        <app-slicemenu [DataList]="AllProductPerCategory" [selected]="selectedCategory"
                       [columnName]="'categoryName'" (newItemEvent)="ShowProducts($event)"></app-slicemenu>
      </div>
    </mat-card>
  </div>

  <div class="col-md-9" *ngIf="ProductsList">
    <div *ngIf="ProductsList.length!=0;then Products else NoProducts"></div>

    <ng-template #NoProducts>
      <div class="col-md-12">
        <p> {{ 'NoDataFound' | translate }}</p>
      </div>
    </ng-template>

    <ng-template #Products>
      <div class="row">
        <div class="col-lg-6" *ngFor="let product of ProductsList">
          <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
            <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
              <mat-card-title class="mat-mdc-card-title text-white">
                <span>{{ 'Code' | translate }} : </span>
                <span> {{ product.productCode }}</span>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="mat-mdc-card-content text-center">
              <div class="row">
                <div class="col-md-2">
                  <img alt="user" width="80" height="80" src="{{product.imgURL | adjust_image_path}}">
                </div>
                <div class="col-md-10">
                                    <span class="productname"> {{ product.name }}
                                      ({{ product.colorName }})
                                    </span>

                  <mat-divider style="margin: 0px 20px;"></mat-divider>
                  <div class="row dataRow">
                    <div class="col-md-5">
                                            <span class="span-title">
                                                {{ 'PricePerMeter' | translate }}
                                            </span>
                      <span class="span-price">
                                                {{ CalcPrice(product.pricePerMeter, product.descount) }}
                        {{ 'EGP' | translate }}
                                            </span>
                    </div>
                    <div class="col-md-2">
                      <mat-divider vertical style="height:15px;width: 20px;"></mat-divider>
                    </div>
                    <div class="col-md-5">
                      <span class="span-title">{{ 'OudPrice' | translate }}</span>
                      <span class="span-price">
                                                {{ product.pricePerOne|arabicPrice }}
                        {{ 'EGP' | translate }}
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </ng-template>
  </div>
</div>
